module.exports = __webpack_public_path__ + "c3ddd2267d941b68a6688eb6fcf20b39.jpg";